/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/core/IsLoopbackIP.ts
 * @create:      2025-07-01 17:10:44.638
 * @modify:      2025-07-11 21:19:12.933
 * @version:     6.0.0
 * @times:       5
 * @lines:       57
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Determines whether the given IP address is a loopback address.
 *
 * Supports both IPv4 and IPv6 loopback addresses, including:
 * - IPv4 loopback (e.g., 127.0.0.1)
 * - IPv6 loopback (::1)
 * - IPv6 link-local addresses with zone index (e.g., fe80::1%eth0)
 * - IPv4-mapped IPv6 loopback (::ffff:127.0.0.1)
 *
 * @param ip - The IP address to check.
 * @returns `true` if the IP address is a loopback address, otherwise `false`.
 * 
 * @since 4.2.4
 * @version 2023-09-02
 */
export function IsLoopbackIP(ip: string) {
    const loopbackIPRegex = /^(127\.|::1|fe80(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::ffff:127\.0\.0\.1)/;

    if (loopbackIPRegex.test(ip)) {
        return true;
    }

    return false;
}
